export const ERROR_CONSTS = {
  PleaseTryAgain: 'Please try again',
  UnableToChangeTask: 'Unable to change this task.',
  FileCouldNotBeSent: 'This file could not be sent',
  AddComponentForClient: 'Please add a component for the client to sign',
  UpdatingDefaultLeadFailed: 'Updating default lead has failed.',
  UpdatingDefaultAssigneesFailed: 'Updating default assignees has failed.',
};
